import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageSuccessComponent } from './medical-prescription/page-success/page-success.component';

const routes: Routes = [
  { path: '', redirectTo: 'medical-prescription', pathMatch: 'full' },
  { path: 'medical-prescription', loadChildren: () => import('./medical-prescription/medical-prescription.module').then(m => m.MedicalPrescriptionModule) },
  { path: 'success', component: PageSuccessComponent, }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
